
export interface IUserDetails {
    user_info: IUser;
    departments: IDepartment[];
    workflows_enabled: boolean;
    chain_of_custody_enabled: boolean;
    client_app_config: IAppConfig;
    isAdvancedUser: boolean;
    image_generation_enabled: boolean;
    chat_user_groups: string[];
    kb_internet_search_enabled: boolean;
    translation_enabled: boolean;
    internet_search_enabled: boolean;
    internet_search_engine: string;
    dashboard_usage_enabled: boolean;
    in_session_multiple_file_upload_enabled: boolean;
    in_session_total_file_size_limit_in_mb: number;
    support_tab_enabled: boolean;
    presentation_enabled: boolean;
    a11y_powerpoint_enabled?: boolean;
    feedback_enabled?: boolean;
    maintenance?: IMaintenance
    chatbot_config?: IChatbotConfig
}

interface IMaintenance {
    is_enabled: boolean;
    message: string;
}

interface IChatbotConfig {
    is_enabled: boolean;
    src: string;
    platform: string;
    id: string;
    tag: string;
}

export interface IUser {
    id: string;
    name: string;
    email: string;
}

export interface IDepartment {
    dpt: string;
    grp: string;
    grp_kb: string;
    grp_access: string[];
    isAdmin: Boolean;
}

export interface IAppConfig {
    primary_title: string;
    secondary_title: string;
}

export interface IStatus {
    message: string;
    status: boolean;
    data?: any;
}

export enum NotificationStatus {
    InProgress = 0,
    Success = 1,
    Warning = 2,
    Info = 3,
    Error = 4
}

export type NotificationType = "success" | "info" | "warning" | "error";

export interface INotification {
    title: string;
    status: NotificationStatus;
    message?: string;
    isRead?: boolean;
    linkConfig?: {
        url?: string;
        onClick?: () => void;
    }
}
export interface ViteMicroApps {
  company: string,
  app: string,
  remoteEntryUrl: string,
  href: string
  title: string
}
